module.exports = {"pagination":{}}


//////////////////
// WEBPACK FOOTER
// ./~/aws-sdk/apis/sts-2011-06-15.paginators.json
// module id = 798
// module chunks = 1